module.exports = __webpack_public_path__ + "static/media/recovery-book3.4fdec27f.png";